import { useQuery } from '@tanstack/react-query';

import { indirectTaxContentIngestionKeys } from './keys';
import { fetchContentIngestionJobs } from './refreshContentIngestion';
import {
  IIndirectTaxContentIngestionJobsResponse,
  INDIRECT_TAX_CONTENT_INGESTION_RUNNING_STATUSES,
} from './types';

const POLL_INTERVAL_MS = 5_000;

const RUNNING_STATUSES = new Set(
  INDIRECT_TAX_CONTENT_INGESTION_RUNNING_STATUSES
);

export function useContentIngestionJobs(limit?: number) {
  return useQuery({
    queryKey: indirectTaxContentIngestionKeys.FETCH_JOBS(limit),
    queryFn: (): Promise<IIndirectTaxContentIngestionJobsResponse> =>
      fetchContentIngestionJobs(limit),
    refetchInterval: (query) => {
      const hasRunningJob = (query.state.data?.jobs ?? []).some((job) =>
        RUNNING_STATUSES.has(job.status)
      );
      return hasRunningJob ? POLL_INTERVAL_MS : false;
    },
  });
}
